import { getFile, list } from "./endpoints";
import {
  archive,
  create,
  createDraft,
  get,
  getInsights,
  listDirectory,
  publishDraft,
  pushDraftFile,
  removeAuthor,
  setAuthor,
  setFeedback,
  updateDraft,
} from "./manage";

export { agentVersionFilePath, agentVersionFileRoute, service } from "./endpoints";
export {
  AgentDetail,
  AgentDetails,
  AgentFileRole,
  AgentRole,
  AgentVersionDetails,
  AgentVersionStatus,
} from "./manage";
export {
  AgentListing,
  AgentVersionFileParams,
  AgentVersionParams,
  ListAgentsQuery,
  ListAgentsResponse,
} from "./schemas";

export const contract = {
  list,
  create,
  get,
  archive: { set: archive },
  directory: { list: listDirectory },
  authors: { set: setAuthor, delete: removeAuthor },
  insights: { get: getInsights },
  feedback: { set: setFeedback },
  drafts: {
    create: createDraft,
    update: updateDraft,
    publish: publishDraft,
    files: { set: pushDraftFile },
  },
  versions: { files: { get: getFile } },
} as const;
